const DEFUALT_STATE = {
  authenticated: null,
};

export const userInfo = (state = DEFUALT_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    default:
      return state;
  }
};
